import request from '@/utils/request'
// 微信支付
export function webWechatPay(params) {
  return request({
    url: '/pay/wechat/getWebWechatPay',
    method: 'get',
    params: params
  })
}
// 支付宝支付
export function webAlipay(params) {
  return request({
    url: '/pay/alipay/getWebAlipay',
    method: 'get',
    params: params
  })
}